module.exports = __webpack_public_path__ + "img/ppt.0f72da05.png";